export const NII_REPORT_VALIDITY_NOTICE =
  'This NII inspection report is only valid on the next scheduled inspection assuming there are no changes to process conditions and/or expected degradation. Any changes to expected degradation will require an updated NII assessment.'
